import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account help" title="Forgot your password?">
      {sent ? (
        <div className="space-y-4 text-center" data-testid="forgot-password-sent">
          <MailCheck className="mx-auto h-10 w-10 text-emerald-400" />
          <p className="text-sm text-muted-foreground">{sent}</p>
          <p className="text-xs text-muted-foreground">Don't see it? Check your spam folder.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-muted-foreground">Enter the email you sign in with and we'll email you a link to choose a new password.</p>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="forgot-password-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-password-submit-button">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-muted-foreground">
        <Link to="/login" className="text-emerald-400 hover:underline" data-testid="forgot-password-back-link">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
